<template>
  <div class="d-flex flex-column flex-lg-row">
    <div class="d-flex flex-column flex-row-fluid mb-10 mb-lg-0">
      <div class="card card-flush shadow-none p-0 m-0" id="kt_geral">
        <div
          v-if="this.loadingGrupos"
          class="card-header cover d-none d-md-block"
          id="kt_geral_header"
        >
          <div v-bind:data-kt-indicator="this.loadingGrupos ? 'on' : 'off'">
            <span class="indicator-progress">
              carregando grupos...
              <span
                class="spinner-border spinner-border-sm align-middle ms-2"
              ></span>
            </span>
          </div>
        </div>
        <div
          v-else
          class="card-header cover d-none d-md-block"
          id="kt_geral_header"
        >
          <button
            class="left button-scroll"
            ref="leftButton"
            @click="leftScroll()"
          >
            <i class="fas fa-angle-double-left"></i>
          </button>
          <div class="scroll-images" ref="scrollImages">
            <template v-for="(grupo, index) in this.grupos" :key="index">
              <div
                :id="'grupo' + index"
                @click="this.selecionarGrupo(grupo.id, index)"
                class="card card-body bg-hover-secondary child-scroll-images me-5"
                :class="[
                  this.grupoSelecionado !== null &&
                  this.grupoSelecionado === grupo.id
                    ? 'bg-secondary border border-secondary'
                    : '',
                ]"
              >
                <div class="d-flex align-items-center">
                  <div class="symbol symbol-40px me-5">
                    <div
                      :class="[
                        'symbol-label fs-2 fw-bold bg-light-secondary text-secondary',
                      ]"
                    >
                      {{
                        grupo.descricao
                          ? grupo.descricao.substring(0, 1).toUpperCase()
                          : ""
                      }}
                    </div>
                  </div>
                  <div class="flex-grow-1">
                    <a class="text-dark fw-bold fs-7">{{ grupo.descricao }}</a>
                    <span class="text-muted fs-8 d-block fw-semobold"
                      >{{ grupo["Produto@odata.count"] }} produtos</span
                    >
                  </div>
                </div>
              </div>
            </template>
          </div>
          <button
            class="right button-scroll"
            ref="rightButton"
            @click="rightScroll()"
          >
            <i class="fas fa-angle-double-right"></i>
          </button>
        </div>
        <div class="card-body px-0 pb-0 d-none d-md-block" id="kt_geral_body">
          <div style="max-height: 450px; overflow-y: auto; overflow-x: hidden">
            <div v-if="this.loadingProdutos">
              <div
                v-bind:data-kt-indicator="this.loadingProdutos ? 'on' : 'off'"
              >
                <span class="indicator-progress">
                  carregando produtos...
                  <span
                    class="spinner-border spinner-border-sm align-middle ms-2"
                  ></span>
                </span>
              </div>
            </div>
            <div v-else class="row g-6">
              <template v-for="produto in this.produtos" :key="produto">
                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-3">
                  <div class="card card-flush flex-row-fluid mw-100 h-100 p-0">
                    <div class="d-flex flex-column w-100 h-100">
                      <div
                        v-if="produto.imagem"
                        class="symbol flex-shrink-0 m-4 align-self-center"
                      >
                        <div
                          class="symbol-label h-100px min-w-100px fs-2 fw-bold bg-light-dark"
                          :style="{
                            'background-image': `url(${
                              this.$utils.getUrl() + produto.imagem
                            })`,
                          }"
                        ></div>
                      </div>
                      <div
                        v-else
                        class="symbol flex-shrink-0 m-4 align-self-center"
                      >
                        <span class="symbol-label h-100px min-w-100px">
                          <img
                            src="media/svg/files/blank-image.svg"
                            class="img-fluid h-50 rounded-2"
                            alt=""
                          />
                        </span>
                      </div>
                      <div class="d-flex flex-column h-100 mx-3">
                        <span
                          class="fw-bold text-gray-800 cursor-pointer text-hover-primary fs-6 mb-2"
                          >{{ produto.nome }}</span
                        >
                        <span class="text-muted text-gray-500 fs-8 mb-2">{{
                          produto.descricao
                        }}</span>
                        <span class="text-muted text-gray-700 fs-8 mb-2">
                          <span
                            class="bullet bullet-dot me-1 h-5px w-5px"
                            :class="
                              produto.quantidade < 0
                                ? 'bg-danger'
                                : produto.quantidade === 0
                                ? 'bg-warning'
                                : 'bg-success'
                            "
                          ></span>
                          {{ produto.quantidade }} Disponível</span
                        >
                        <span class="fw-bold text-primary fs-6 mb-2 mt-auto">
                          R$
                          {{
                            this.$utils.formatarNumero(produto.preco, 2)
                          }}</span
                        >
                        <button
                          class="btn btn-sm btn-secondary fs-8 my-2 mt-auto"
                          @click="this.selecionarProduto(produto)"
                        >
                          <span class="svg-icon svg-icon">
                            <inline-svg
                              src="media/icons/duotune/general/gen041.svg"
                            />
                          </span>
                          Adicionar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div class="row mt-4" id="kt_geral_paginacao">
            <el-pagination
              v-model:current-page="pagination.page"
              @current-change="currentPageChange"
              :page-size="pagination.rowsPerPage"
              layout="prev, pager, next"
              :total="pagination.total"
              background
            >
            </el-pagination>
          </div>
        </div>
        <div class="card-footer px-0 pb-0" id="kt_geral_footer">
          <div
            class="card card-body"
            id="kt_produto_input_lancamento"
            v-bind:class="[active ? 'fixed-top shadow' : '']"
          >
            <div class="row">
              <div class="d-flex mb-2">
                <div
                  class="input-group mb-md-2"
                  v-bind:data-kt-indicator="loadingProduto ? 'on' : 'off'"
                >
                  <button
                    class="input-group-text svg-icon svg-icon-dark px-2 svg-icon-2x cursor-pointer"
                    @click="this.executarLeituraBarras()"
                    :disabled="this.loadingProduto"
                  >
                    <inline-svg
                      src="media/icons/duotune/ecommerce/ecm010.svg"
                    />
                  </button>
                  <div
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Insert - Qtd"
                    @click="this.informarQuantidade()"
                    class="input-group-text justify-content-center align-middle d-flex flex-column py-0 align-items-center cursor-pointer"
                  >
                    <div class="fw-bold text-muted fs-7">Qtd</div>
                    <div class="fw-bold fs-6 text-dark">
                      {{ this.qtdAtual }}
                    </div>
                  </div>
                  <input
                    autocomplete="off"
                    type="search"
                    id="txtCodigo"
                    v-model="pesquisaProduto"
                    @keydown.stop.prevent.enter="
                      this.loadingProduto === false ? this.incluirProduto() : ``
                    "
                    :readonly="this.loadingProduto"
                    class="form-control flex-grow-1 fs-lg-3 fs-md-4 fs-sm-5"
                    placeholder="Informe o código do produto"
                  />
                  <span
                    class="indicator-progress position-absolute mt-4 end-0 me-14 me-md-4"
                  >
                    <span
                      class="spinner-border align-middle"
                      style="width: 1.6rem; height: 1.6rem"
                    ></span>
                  </span>
                  <button
                    class="dropdown-toggle input-group-text d-md-none"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  ></button>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li class="mx-2">
                      <button
                        @click="this.modalProdutos(true)"
                        class="btn btn-sm dropdown-item"
                      >
                        <span class="svg-icon svg-icon-1 align-self-center">
                          <inline-svg
                            src="media/icons/duotune/ecommerce/ecm009.svg"
                            class="me-2"
                          />Pesquisar Produtos
                        </span>
                      </button>
                    </li>
                    <li class="mx-2">
                      <button
                        class="btn btn-sm dropdown-item"
                        @click="this.modalClientes(true)"
                      >
                        <span class="svg-icon svg-icon-1 align-self-center">
                          <inline-svg
                            src="media/icons/duotune/communication/com005.svg"
                            class="me-2"
                          />Selecionar cliente
                        </span>
                      </button>
                    </li>
                    <li class="mx-2">
                      <button
                        class="btn btn-sm dropdown-item"
                        @click="this.informarQuantidade(true)"
                      >
                        <span class="svg-icon svg-icon-1 align-self-center">
                          <inline-svg
                            src="media/icons/duotune/general/gen054.svg"
                            class="me-2"
                          />Informar quantidade
                        </span>
                      </button>
                    </li>
                    <li class="mx-2">
                      <button
                        class="btn btn-sm dropdown-item"
                        @click="this.removerProduto(this.itemSelecionado)"
                      >
                        <span class="svg-icon svg-icon-1 align-self-center">
                          <inline-svg
                            src="media/icons/duotune/general/gen027.svg"
                            class="me-2"
                          />Delete - Item
                        </span>
                      </button>
                    </li>
                    <li class="mx-2">
                      <button
                        class="btn btn-sm dropdown-item"
                        @click="this.cancelarVendaTemp()"
                      >
                        <span class="svg-icon svg-icon-1 align-self-center">
                          <inline-svg
                            src="media/icons/duotune/general/gen040.svg"
                            class="me-2"
                          />Cancelar venda
                        </span>
                      </button>
                    </li>
                    <li class="mx-2">
                      <button class="btn btn-sm dropdown-item">
                        <span class="svg-icon svg-icon-1 align-self-center">
                          <inline-svg
                            src="media/icons/duotune/general/gen019.svg"
                            class="me-2"
                          />Funções
                        </span>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="row d-none d-md-block">
              <div class="d-flex flex-wrap">
                <button
                  id="btnPesquisarProdutos"
                  class="btn btn-bg-light btn-active-icon-primary btn-active-text-primary me-2 mb-2"
                  @click="this.modalProdutos(true)"
                >
                  <div class="d-flex flex-column justify-content-center">
                    <span class="svg-icon svg-icon-2hx">
                      <inline-svg
                        src="media/icons/duotune/ecommerce/ecm009.svg"
                      /> </span
                    >PgUP - Produtos
                  </div>
                </button>
                <button
                  id="btnCliente"
                  class="btn btn-bg-light btn-active-icon-primary btn-active-text-primary me-2 mb-2"
                  @click="this.modalClientes(true)"
                >
                  <div class="d-flex flex-column justify-content-center">
                    <span class="svg-icon svg-icon-2hx">
                      <inline-svg
                        src="media/icons/duotune/communication/com005.svg"
                      /> </span
                    >F3 - Cliente
                  </div>
                </button>
                <button
                  id="btnQtd"
                  class="btn btn-bg-light btn-active-icon-primary btn-active-text-primary me-2 mb-2"
                  @click="this.informarQuantidade()"
                >
                  <div class="d-flex flex-column justify-content-center">
                    <span class="svg-icon svg-icon-2hx">
                      <inline-svg
                        src="media/icons/duotune/general/gen054.svg"
                      />
                    </span>
                    Insert - Qtd
                  </div>
                </button>
                <button
                  id="btnDelete"
                  class="btn btn-bg-light btn-active-icon-primary btn-active-text-primary me-2 mb-2"
                  @click="this.removerProduto(this.itemSelecionado)"
                >
                  <div class="d-flex flex-column justify-content-center">
                    <span class="svg-icon svg-icon-2hx">
                      <inline-svg
                        src="media/icons/duotune/general/gen027.svg"
                      />
                    </span>
                    Delete - Item
                  </div>
                </button>
                <button
                  id="btnCancelar"
                  class="btn btn-bg-light btn-active-icon-primary btn-active-text-primary me-2 mb-2"
                  @click="this.cancelarVendaTemp()"
                >
                  <div class="d-flex flex-column justify-content-center">
                    <span class="svg-icon svg-icon-2hx">
                      <inline-svg
                        src="media/icons/duotune/general/gen040.svg"
                      />
                    </span>
                    F6 - Cancelar
                  </div>
                </button>
                <button
                  id="btnFuncoes"
                  class="btn btn-bg-light btn-active-icon-primary btn-active-text-primary me-2 mb-2"
                >
                  <div class="d-flex flex-column justify-content-center">
                    <span class="svg-icon svg-icon-2hx">
                      <inline-svg
                        src="media/icons/duotune/general/gen019.svg"
                      />
                    </span>
                    F11 - Funções
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="flex-column flex-lg-row-auto w-100 w-lg-450px w-xl-550px ms-lg-7 ms-xl-10"
    >
      <div class="card card-flush p-0 m-0" id="kt_produtos_container">
        <div class="card-body pt-5" id="kt_produtos_body">
          <div id="kt_produtos_content">
            <div v-if="this.loadingItensVenda">
              <div
                v-bind:data-kt-indicator="this.loadingItensVenda ? 'on' : 'off'"
              >
                <span class="indicator-progress">
                  carregando itens...
                  <span
                    class="spinner-border spinner-border-sm align-middle ms-2"
                  ></span>
                </span>
              </div>
            </div>
            <template
              v-else
              v-for="(item, index) in this.venda.PdvItem"
              :key="index"
            >
              <div
                :id="'prod' + index"
                class="d-flex align-items-center p-2"
                :class="[
                  this.itemSelecionado === index
                    ? 'bg-secondary rounded'
                    : 'cursor-pointer',
                ]"
                @click="selectItem(index)"
              >
                <div v-if="item.Produto.imagem" class="symbol symbol-40px me-5">
                  <div
                    class="symbol-label fs-2 fw-bold bg-light-dark"
                    :style="{
                      'background-image': `url(${
                        this.$utils.getUrl() + item.Produto.imagem
                      })`,
                    }"
                  ></div>
                </div>
                <div v-else class="symbol symbol-40px me-5">
                  <div
                    :class="[
                      'symbol-label fs-2 fw-bold bg-light-secondary text-secondary',
                    ]"
                  >
                    {{
                      item.nome ? item.nome.substring(0, 1).toUpperCase() : ""
                    }}
                  </div>
                </div>
                <div class="flex-grow-1 me-5">
                  <a class="text-dark fw-bold text-hover-primary fs-4">{{
                    item.nome
                  }}</a>
                  <span class="text-muted d-block fw-semobold">{{
                    item.variacao
                  }}</span>
                  <div class="d-flex flex-row align-items-center mt-2">
                    <div class="d-flex align-items-center me-2">
                      <button
                        class="btn btn-sm btn-circle btn-icon btn-active-danger me-2"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Retirar"
                        @click="this.removerQtdProduto(index)"
                        style="max-width: 25px; max-height: 25px"
                      >
                        <span class="svg-icon svg-icon-1">
                          <inline-svg
                            src="media/icons/duotune/general/gen042.svg"
                          />
                        </span>
                      </button>
                      <span class="fw-bold fs-5 text-dark">{{ item.qtd }}</span>
                      <button
                        class="btn btn-sm btn-circle btn-icon btn-active-primary ms-2"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Adicionar"
                        @click="this.adicionarQtdProduto(index)"
                        style="max-width: 25px; max-height: 25px"
                      >
                        <span class="svg-icon svg-icon-1">
                          <inline-svg
                            src="media/icons/duotune/general/gen041.svg"
                          />
                        </span>
                      </button>
                    </div>
                    <span class="text-gray-800 d-block fs-6 fw-semobold">
                      Preço:
                      {{ this.$utils.formatarNumero(item.preco) }}</span
                    >
                  </div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="fw-bold fs-5 text-dark">
                    {{ this.$utils.formatarNumero(item.total, 2) }}
                  </div>
                </div>
                <div class="d-flex align-items-end ms-2">
                  <button
                    class="btn btn-icon btn-active-danger btn-sm"
                    @click="this.removerProduto(index)"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Remover"
                  >
                    <span class="svg-icon svg-icon-5 m-0">
                      <inline-svg
                        src="media/icons/duotune/general/gen027.svg"
                      />
                    </span>
                  </button>
                </div>
              </div>
              <div
                class="separator separator-dashed my-1"
                v-if="this.venda.PdvItem.length - 1 !== index"
              ></div>
            </template>
          </div>
        </div>
        <div id="kt_produtos_footer" class="card-footer pt-4">
          <div class="d-flex flex-column">
            <div
              v-if="
                this.venda.cliente_nome &&
                this.venda.cliente_nome !== null &&
                this.venda.cliente_nome !== ''
              "
            >
              <div class="separator separator-dashed mb-3"></div>
              <div class="d-flex mb-2 align-items-center">
                <div
                  v-if="this.venda.Cliente && this.venda.Cliente.foto"
                  class="symbol symbol-35px symbol-circle me-5"
                >
                  <div
                    class="symbol-label fs-2 fw-bold bg-light-dark"
                    :style="{
                      'background-image': `url(${
                        this.$utils.getUrl() + this.venda.Cliente.foto
                      })`,
                    }"
                  ></div>
                </div>
                <div v-else class="symbol symbol-35px symbol-circle me-5">
                  <div
                    :class="[
                      'symbol-label fs-2 fw-bold bg-warning text-inverse-warning',
                    ]"
                  >
                    {{
                      this.venda.cliente_nome
                        ? this.venda.cliente_nome.substring(0, 1).toUpperCase()
                        : ""
                    }}
                  </div>
                </div>
                <div class="flex-grow-1 me-5">
                  <a class="text-dark fw-bold text-hover-primary fs-6">{{
                    this.venda.cliente_nome
                  }}</a>
                  <span class="text-muted d-block fw-semobold fs-8">{{
                    this.venda.cliente_documento
                  }}</span>
                </div>
              </div>
            </div>
            <div class="separator separator-dashed mb-3"></div>
            <div class="d-flex mb-2">
              <div class="flex-grow-1">
                <a
                  class="text-dark fw-bold text-gray-600 text-hover-primary fs-6"
                  >Qtd Item</a
                >
              </div>
              <div class="d-flex justify-content-end">
                <div class="fw-bold fs-5 pe-1">
                  {{ this.venda.PdvItem.length }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="flex-grow-1">
                <a
                  class="text-dark fw-bold text-gray-600 text-hover-primary fs-6"
                  >Subtotal</a
                >
              </div>
              <div class="d-flex justify-content-end">
                <div class="fw-bold fs-5 pe-1">
                  R$
                  {{ this.$utils.formatarNumero(this.venda.total_produtos) }}
                </div>
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="flex-grow-1">
                <a
                  class="text-dark fw-bold text-gray-600 text-hover-primary fs-6"
                  >Desconto</a
                >
              </div>
              <div class="d-flex justify-content-end">
                <div class="fw-bold fs-5 pe-1">
                  R$
                  {{ this.$utils.formatarNumero(this.venda.total_descontos) }}
                </div>
              </div>
            </div>
            <div class="separator separator-dashed my-3"></div>
            <div class="d-flex mb-2">
              <div class="flex-grow-1">
                <a
                  class="text-dark fw-bold text-gray-900 text-hover-primary fs-1"
                  >Total</a
                >
              </div>
              <div class="d-flex justify-content-end">
                <div class="fw-bold fs-1 pe-1">
                  R$ {{ this.$utils.formatarNumero(this.venda.total) }}
                </div>
              </div>
            </div>
            <button
              @click="this.finalizarVenda()"
              class="btn btn-danger btn-icon-warning fs-4 mt-3"
            >
              F5 - Finalizar venda
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <QtdModal
    v-if="exibirQtd"
    :qtdAtual="this.qtdAtual"
    @exibirModalEditarQuantidade="exibirModalEditarQuantidade"
    @confirmarModalEditarQuantidade="confirmarModalEditarQuantidade"
  ></QtdModal>
  <!-- <component
    :is="modalComponent"
    v-if="exibirPesquisaProdutos"
    @exibirModalProdutos="modalProdutos"
    @selecionarProduto="selecionarProduto"
  ></component> -->
  <ProdutosModal
    v-if="exibirPesquisaProdutos"
    @exibirModalProdutos="modalProdutos"
    @selecionarProduto="selecionarProduto"
  >
  </ProdutosModal>
  <ClientesModal
    v-if="exibirClientes"
    @exibirModalClientes="modalClientes"
    @selecionarCliente="selecionarCliente"
  >
  </ClientesModal>
  <LeituraBarrasModal
    v-if="exibirLeituraBarras"
    @exibirModalLeituraBarras="exibirModalLeituraBarras"
    @confirmarModalLeituraBarras="confirmarModalLeituraBarras"
  >
  </LeituraBarrasModal>
  <FinalizarModal
    v-if="exibirFinalizarVenda"
    @exibirModalFinalizarVenda="exibirModalFinalizarVenda"
    @confirmarModalFinalizarVenda="confirmarModalFinalizarVenda"
  >
  </FinalizarModal>
  <LoadingModal
    :nomeRef="'loadingModalPDV'"
    :mensagem="this.loadingMensagem"
    v-if="this.loadingGeral === true"
  ></LoadingModal>
</template>

<script>
import { markRaw } from "vue";
import { mapState } from "vuex";
import {
  hideModalId,
  hideModal,
  getOrCreateInstanceModal,
} from "@/core/helpers/dom";
import { MenuComponent } from "@/assets/ts/components";
import LoadingModal from "@/components/modals/general/LoadingModal.vue";
import { useToast } from "vue-toastification";

import LeituraBarrasModal from "@/views/pdv/LeituraBarrasModal.vue";
import QtdModal from "@/views/pdv/QtdModal.vue";
import ClientesModal from "@/views/clientes/ClientesModal.vue";
import ProdutosModal from "@/views/produtos/ProdutosModal.vue";
import FinalizarModal from "@/views/pdv/FinalizarModal.vue";

const vendaInicializada = {
  id: 0,
  guid: "",
  cfop: "",
  total_seguro: 0,
  total_ipi: 0,
  total_frete: 0,
  total_descontos: 0,
  total_acrescimo: 0,
  total_outras: 0,
  total_produtos: 0,
  total: 0,
  base_icms: 0,
  total_icms: 0,
  base_icms_sub: 0,
  total_icms_sub: 0,
  peso_bruto: 0,
  peso_liquido: 0,
  comissao_per: 0,
  comissao_valor: 0,
  observacao: "",
  total_pis: 0,
  total_cofins: 0,
  total_imposto: 0,
  total_imposto_estadual: 0,
  total_fcp: 0,
  total_fcp_st: 0,
  cancelado: "0",
  cliente_documento: "",
  cliente_nome: "",
  id_cliente: null,
  Cliente: {},
  PdvItem: [],
};
export default {
  components: {
    QtdModal,
    ClientesModal,
    LeituraBarrasModal,
    ProdutosModal,
    FinalizarModal,
    LoadingModal,
  },
  computed: {
    ...mapState("auth", ["user"]),
    isLeftDisabled() {
      return this.scrollImages ? this.scrollImages.scrollLeft === 0 : true;
    },
    isRightDisabled() {
      return this.scrollImages
        ? this.scrollImages.scrollLeft === this.scrollLength
        : true;
    },
  },
  methods: {
    async carregarGrupos() {
      this.loadingGrupos = true;

      let filtro = "?&$filter=ativo eq '1'&$count=true&$top=0";

      await this.$store.dispatch("produto/getProdutoOData", filtro).then(
        async (ret) => {
          let grupoTodos = {
            id: 0,
            descricao: "Todos",
            "Produto@odata.count": ret["@odata.count"],
          };
          this.grupos.push(grupoTodos);
        },
        async (error) => {
          if (error !== "") {
            console.log(error);
            await this.$swal.showErrorAlert(error);
          }
        }
      );

      filtro =
        "?&$filter=ativo eq '1'&$orderby=descricao&$expand=produto($count=true;$top=0)";

      await this.$store.dispatch("grupo/getGrupoOData", filtro).then(
        async (ret) => {
          this.pagination.total = ret["@odata.count"];
          this.grupos.push(...ret.value);
        },
        async (error) => {
          if (error !== "") {
            console.log(error);
            await this.$swal.showErrorAlert(error);
          }
        }
      );
      this.grupoSelecionado = 0;
      this.loadingGrupos = false;

      if (this.eventoScrollRegistrado === false) {
        this.$nextTick(() => {
          this.scrollImages = this.$refs.scrollImages;
          this.scrollLength = this.scrollImages
            ? this.scrollImages.scrollWidth - this.scrollImages.clientWidth
            : 0;
          this.checkScroll();
          this.scrollImages.addEventListener("scroll", this.checkScroll);
          window.addEventListener("resize", this.checkScroll);
        });
        this.eventoScrollRegistrado = true;
      }
      this.carregarProdutosGrupo();
    },

    async selecionarGrupo(grupo, index) {
      this.grupoSelecionado = grupo;
      this.carregarProdutosGrupo();
      this.focusElement("grupo" + index);
      this.codigoFocus();
    },

    async carregarProdutosGrupo() {
      this.loadingProdutos = true;
      try {
        var page = (this.pagination.page - 1) * this.pagination.rowsPerPage;

        var filtro =
          "?&$count=true&$skip=" +
          page +
          "&$top=" +
          this.pagination.rowsPerPage +
          "&$select=id,nome,descricao,ativo,guid,cod_referencia,ean,imagem,preco,preco_promocao,quantidade&$orderby=nome" +
          "&$filter=ativo eq '1'";

        if (this.grupoSelecionado !== null && this.grupoSelecionado > 0) {
          filtro += " and id_grupo eq " + this.grupoSelecionado;
        }

        if (this.filterOData !== "" && this.filterOData !== undefined) {
          filtro += this.filterOData;
        }

        await this.$store.dispatch("produto/getProdutoOData", filtro).then(
          async (ret) => {
            this.pagination.total = ret["@odata.count"];
            this.produtos = ret.value;
            //console.log(this.produtos);
          },
          async (error) => {
            if (error !== "") {
              console.log(error);
              await this.$swal.showErrorAlert(error);
            }
          }
        );
      } catch (error) {
        console.log(error);
        await this.$swal.showErrorAlert(error);
      }
      this.loadingProdutos = false;
    },

    async incluirProduto() {
      var filterOdata = "";
      this.errosGerais = {};
      this.errosValidacao = [];

      filterOdata = "&$filter=(codigo eq " + this.pesquisaProduto;
      filterOdata += "or ean eq '" + this.pesquisaProduto + "')";

      if (this.pesquisaProduto != "") {
        if (filterOdata != "") {
          this.loadingProduto = true;
          try {
            var retOdata = await this.$store.dispatch(
              "produto/getProdutoOData",
              "?$expand=Adicional($expand=AdicionalGrupo($expand=AdicionalGrupoItem)),ProdutoTributacao" +
                filterOdata
            );
            if (retOdata.value !== null && retOdata.value.length > 0) {
              var produto = retOdata.value[0];
              await this.selecionarProduto(produto);
            } else {
              await this.$swal.showInvalidAlert(
                "Nenhum Produto foi encontrado com o código informado!",
                (alert) => {
                  this.pesquisaProduto = "";
                  this.codigoFocus();
                }
              );
            }
          } catch (error) {
            console.log(error);
          }
          this.loadingProduto = false;
          this.codigoFocus();
        } else {
          console.log("Verifique o código do produto!");
          await this.$swal.showInvalidAlert(
            "Verifique o código do produto!",
            (alert) => {
              this.pesquisaProduto = "";
              this.codigoFocus();
            }
          );
        }
      }
    },

    async selecionarProduto(produto) {
      this.errosGerais = {};
      try {
        var ret = await this.$store.dispatch("produto/getProduto", produto.id);
        if (ret.Success === true) {
          var prod = ret.Data;
          if (produto.brinde === undefined || produto.brinde === null) {
            prod.brinde = "N";
          } else {
            prod.brinde = produto.brinde;
            prod.qtd = produto.qtd;
          }
          prod.promocaoAtiva = this.verificarPromocaoAtiva(prod);
          if (prod.Estoque != null && prod.Estoque.length > 0) {
            prod.id_estoque = prod.Estoque[0].id;
          }
          if (prod.Adicional != null) {
            // this.adicionalProduto = prod;
            // this.addFaturamentoItem = true;
            // this.indexEdicaoFaturamentoItem = -1;
            // this.modalAdicional(true);

            this.preencheProdutoSelecionado(prod, true, -1);
          } else {
            if (prod.Estoque != null && prod.Estoque.length > 1) {
              // this.produtoEstoque = prod;
              // this.addFaturamentoItem = true;
              // this.indexEdicaoFaturamentoItem = -1;
              // this.modalEstoques(true);
              this.preencheProdutoSelecionado(prod, true, -1);
            } else {
              this.preencheProdutoSelecionado(prod, true, -1);
            }
          }
        }
      } catch (error) {
        this.errosGerais = error;
      }
    },
    verificarPromocaoAtiva(produto) {
      var promocaoAtiva = false;
      if (produto.promocao_ativa === "1" && produto.preco_promocao > 0) {
        if (new Date(produto.data_inicio_promocao) <= new Date()) {
          if (new Date(produto.data_fim_promocao) >= new Date()) {
            if (produto.promocao_tipo === "0") {
              promocaoAtiva = true;
            } else {
              if (produto.promocao_dias_semana !== null) {
                var diaDaSemana = new Date().getDay();
                if (produto.promocao_dias_semana.includes(diaDaSemana)) {
                  promocaoAtiva = true;
                }
              }
            }
          }
        }
      }
      return promocaoAtiva;
    },

    async preencheProdutoSelecionado(produto, add, index) {
      try {
        var listSubItem = [];
        var quantidade = produto.qtd ? produto.qtd : this.qtdAtual;
        var obs = "";
        let idPedido = 0;

        if (produto.Adicional != null) {
          for (var i = 0; i < produto.Adicional.AdicionalGrupo.length; i++) {
            for (
              var y = 0;
              y < produto.Adicional.AdicionalGrupo[i].AdicionalGrupoItem.length;
              y++
            ) {
              var item =
                produto.Adicional.AdicionalGrupo[i].AdicionalGrupoItem[y];
              if (item.qtd > 0) {
                obs +=
                  (obs != "" ? "\r\n" : "") +
                  item.qtd +
                  "  " +
                  item.descricao +
                  (item.valor > 0
                    ? " - " + this.$utils.formatarNumero(item.valor)
                    : "");

                listSubItem.push({
                  id: null,
                  id_pdv: null,
                  id_pdv_item: null,
                  id_adicional_grupo_item: item.id,
                  item: 0,
                  descricao: item.descricao,
                  qtd: item.qtd,
                  preco: item.valor,
                  total: 0,
                  desconto: 0,
                  acrescimo: 0,
                  cod_referencia: item.cod_referencia,
                  observacao: "",
                });
              }
            }
          }
        }
        obs += produto.observacao
          ? (obs != "" ? "\r\nObs: " : "") + produto.observacao
          : "";

        if (
          produto.PedidoSubItem !== undefined &&
          produto.PedidoSubItem !== null &&
          produto.PedidoSubItem.length > 0
        ) {
          for (const item in produto.PedidoSubItem) {
            const adicional = produto.PedidoSubItem[item];
            obs +=
              (obs != "" ? "\r\n" : "") +
              adicional.qtd +
              "  " +
              adicional.descricao +
              (adicional.preco > 0
                ? " - " + this.$utils.formatarNumero(adicional.preco)
                : "");
            listSubItem.push({
              id: null,
              id_faturamento: null,
              id_faturamento_item: null,
              id_adicional_grupo_item: adicional.id_adicional_grupo_item,
              item: 0,
              descricao: adicional.descricao,
              qtd: adicional.qtd,
              preco: adicional.preco,
              total: adicional.total,
              desconto: adicional.desconto,
              acrescimo: adicional.acrescimo,
              cod_referencia: adicional.cod_referencia,
              observacao: adicional.observacao,
            });
          }
        }

        if (
          produto.id_pedido !== undefined &&
          produto.id_pedido !== null &&
          produto.id_pedido > 0
        ) {
          idPedido = produto.id_pedido;
        }

        if (add === true) {
          var preco =
            produto.promocaoAtiva === true
              ? produto.preco_promocao
              : produto.preco;

          let cfop = String(produto.ProdutoTributacao.cfop);

          let itemAdicionar = {
            id: 0,
            id_pdv: 0,
            item: 0,
            id_produto: produto.id,
            id_estoque: produto.id_estoque,
            id_estoque_variacao: null,
            und: produto.und,
            nome: produto.nome,
            qtd: quantidade,
            custo: produto.preco_custo,
            preco: preco,
            desconto: 0,
            acrescimo: 0,
            valor_frete: 0,
            valor_outras: 0,
            valor_seguro: 0,
            total_sub_itens: 0,
            total: 0,
            cod_referencia: produto.cod_referencia,
            observacao: obs,
            Produto: produto,
            PdvSubItem: listSubItem.length > 0 ? listSubItem : [],
            brinde: produto.brinde,
            st: produto.ProdutoTributacao.st,
            cfop: cfop,
            csosn: produto.ProdutoTributacao.csosn,
            icms: parseFloat(produto.ProdutoTributacao.icms),
            ipi: produto.ProdutoTributacao.ipi,
            mva: produto.ProdutoTributacao.mva,
            aliqi: parseFloat(produto.ProdutoTributacao.aliqi),
            reducao: produto.ProdutoTributacao.reducao,
            base_icms: 0,
            total_icms: 0,
            base_icms_sub: 0,
            total_icms_sub: 0,
            total_ipi: 0,
            det_cod_barras: null,
            det_metragem: null,
            det_pesagem: null,
            det_tipo_embalagem: null,
            det_tolerancia: null,
            id_vendedor: null,
            comissao: 0,
            xped: null,
            nitemped: null,
            peso_bruto: 0,
            peso_liquido: 0,
            qtd_entregue: 0,
            qtd_importada: 0,
            tipo_prod: null,
            cancelado: "0",
            id_pedido: idPedido,
            pis_st: produto.ProdutoTributacao.pis_st,
            pis_base: 0,
            pis_aliq: produto.ProdutoTributacao.pis_aliq,
            total_pis: 0,
            cofins_st: produto.ProdutoTributacao.cofins_st,
            cofins_base: 0,
            cofins_aliq: produto.ProdutoTributacao.cofins_aliq,
            total_cofins: 0,
            total_imposto: 0,
            total_imposto_estadual: 0,
            p_fcp: produto.ProdutoTributacao.aliq_fcp,
            v_fcp: 0,
            p_fcp_st: produto.ProdutoTributacao.aliq_fcp,
            v_fcp_st: 0,
          };
          this.venda.PdvItem.push(itemAdicionar);
        } else {
          this.venda.PdvItem[index].qtd = quantidade;
        }

        this.qtdAtual = 1;
        this.pesquisaProduto = "";
        this.recalcularValores();

        if (add === true) {
          this.itemSelecionado = this.venda.PdvItem.length - 1;
          this.focusElement("prod" + this.itemSelecionado);
        }
      } catch (error) {
        console.log(error);
      }
    },

    async recalcularValores() {
      var totalProdutos = 0;
      var totalDescontos = 0;
      var totalAcrescimos = 0;
      var totalBaseICMS = 0;
      var totalValorICMS = 0;
      var totalBaseICMSST = 0;
      var totalValorICMSST = 0;
      var totalIPI = 0;
      var totalPesoBruto = 0;
      var totalPesoLiquido = 0;
      let cfops = [];
      let totalPIS = 0;
      let totalCOFINS = 0;
      let totalImposto = 0;
      let totalImpostoEstadual = 0;
      let totalFCP = 0;
      let totalFCPST = 0;

      for (var i = 0; i < this.venda.PdvItem.length; i++) {
        var item = this.venda.PdvItem[i];
        var totalSubItens = 0;
        for (var y = 0; y < item.PdvSubItem.length; y++) {
          var subItem = item.PdvSubItem[y];
          subItem.total = subItem.qtd * subItem.preco;
          totalSubItens += subItem.total;
        }

        item.total_sub_itens = item.qtd * totalSubItens;
        item.total =
          item.qtd * item.preco +
          item.total_sub_itens -
          item.desconto +
          item.acrescimo;

        item.total_ipi = parseFloat(((item.total * item.ipi) / 100).toFixed(2));

        item.pis_base = item.total;
        item.cofins_base = item.total;
        item.total_pis = parseFloat(
          ((item.total * item.pis_aliq) / 100).toFixed(2)
        );
        item.total_cofins = parseFloat(
          ((item.total * item.cofins_aliq) / 100).toFixed(2)
        );

        totalProdutos += item.total;
        totalDescontos += item.desconto;
        totalAcrescimos += item.acrescimo;
        totalIPI += item.total_ipi;
        totalPIS += item.total_pis;
        totalCOFINS += item.total_cofins;

        if (item.peso_bruto > 0) {
          totalPesoBruto += item.qtd * item.peso_bruto;
        } else {
          totalPesoBruto += item.qtd * item.Produto.peso;
        }

        if (item.peso_liquido > 0) {
          totalPesoLiquido += item.qtd * item.peso_liquido;
        } else {
          totalPesoLiquido += item.qtd * item.Produto.peso_liquido;
        }

        if (item.cfop !== undefined && item.cfop !== null) {
          const cfopStr = String(item.cfop);
          if (cfopStr !== "" && !cfops.includes(cfopStr)) {
            cfops.push(cfopStr);
          }
          if (cfopStr !== "") {
            item.cfop = cfopStr;
          }
        }

        var it = this.venda.PdvItem[i];
        var valorFrete = 0;
        var valorOutras = 0;
        var valorSeguro = 0;
        var percentualProporcional = (it.total * 100) / totalProdutos;

        valorFrete = (this.venda.total_frete * percentualProporcional) / 100;
        it.valor_frete = valorFrete;

        valorOutras = (this.venda.total_outras * percentualProporcional) / 100;
        it.valor_outras = valorOutras;

        valorSeguro = (this.venda.total_seguro * percentualProporcional) / 100;
        it.valor_seguro = valorSeguro;

        this.calculaBaseST(i);
        totalBaseICMS += it.base_icms;
        totalValorICMS += it.total_icms;
        totalBaseICMSST += it.base_icms_sub;
        totalValorICMSST += it.total_icms_sub;
        totalFCP += parseFloat(it.v_fcp);
        totalFCPST += parseFloat(it.v_fcp_st);
      }

      this.venda.cfop = cfops.join(",");

      this.venda.total_produtos = totalProdutos;
      this.venda.total_descontos = totalDescontos;
      this.venda.total_acrescimo = totalAcrescimos;
      this.venda.total_ipi = totalIPI;
      this.venda.peso_bruto = totalPesoBruto;
      this.venda.peso_liquido = totalPesoLiquido;

      this.venda.total =
        this.venda.total_produtos +
        this.venda.total_outras +
        this.venda.total_frete +
        this.venda.total_seguro +
        this.venda.total_ipi;

      this.venda.base_icms = totalBaseICMS;
      this.venda.total_icms = totalValorICMS;
      this.venda.base_icms_sub = totalBaseICMSST;
      this.venda.total_icms_sub = totalValorICMSST;
      this.venda.total_pis = totalPIS;
      this.venda.total_cofins = totalCOFINS;
      this.venda.total_imposto = totalImposto;
      this.venda.total_imposto_estadual = totalImpostoEstadual;
      this.venda.total_fcp = totalFCP;
      this.venda.total_fcp_st = totalFCPST;

      this.venda.comissao_valor =
        (this.venda.comissao_per * this.venda.total) / 100;
    },

    calculaBaseST(index) {
      try {
        var item = this.venda.PdvItem[index];
        if (this.user.User.Emitente.crt === 1) {
          if (
            item.csosn &&
            item.csosn !== null &&
            (item.csosn !== "") & (item.csosn.length === 4)
          ) {
            let csosn = item.csosn.substring(1, 4);
            if (csosn === "101") {
              item.base_icms = 0;
              item.total_icms = 0;
              item.base_icms_sub = 0;
              item.total_icms_sub = 0;
            } else if (
              csosn === "102" ||
              csosn === "103" ||
              csosn === "300" ||
              csosn === "400"
            ) {
              item.base_icms = 0;
              item.total_icms = 0;
              item.base_icms_sub = 0;
              item.total_icms_sub = 0;
            } else if (csosn === "201") {
              item.base_icms = 0;
              item.total_icms = 0;
              item.base_icms_sub = this.calculaBCST(index);
              item.total_icms_sub = this.calculaICMSST(index);
              this.calcularFCP(0, item.base_icms_sub, index);
            } else if (csosn === "202") {
              item.base_icms = 0;
              item.total_icms = 0;
              item.base_icms_sub = this.calculaBCST(index);
              item.total_icms_sub = this.calculaICMSST(index);
              this.calcularFCP(0, item.base_icms_sub, index);
            } else if (csosn === "500") {
              item.base_icms = 0;
              item.total_icms = 0;
              item.base_icms_sub = 0;
              item.total_icms_sub = 0;
            } else if (csosn === "900") {
              if (this.configuracao.st_90 === "1") {
                item.base_icms = item.total;
                item.total_icms = (item.base_icms * item.icms) / 100;
              } else {
                item.base_icms = 0;
                item.total_icms = 0;
              }
              item.base_icms_sub = this.calculaBCST(index);
              item.total_icms_sub = this.calculaICMSST(index);
              this.calcularFCP(0, item.base_icms_sub, index);
            } else {
              item.base_icms = 0;
              item.total_icms = 0;
              item.base_icms_sub = 0;
              item.total_icms_sub = 0;
            }
          }
        } else {
          if (item.st !== null && item.st !== "" && item.st.length === 3) {
            let st = item.st.substring(1, 3);
            if (st === "00") {
              if (this.configuracao.st_00 === "1") {
                item.base_icms = item.total;
                item.total_icms = (item.base_icms * item.icms) / 100;
                item.base_icms_sub = 0;
                item.total_icms_sub = 0;
              } else {
                item.base_icms = 0;
                item.total_icms = 0;
              }
              this.calcularFCP(item.base_icms, item.base_icms_sub, index);
            } else if (st === "10") {
              if (this.configuracao.st_10 === "1") {
                item.base_icms = item.total;
                item.total_icms = (item.base_icms * item.icms) / 100;
                item.base_icms_sub = this.calculaBCST(index);
                item.total_icms_sub = this.calculaICMSST(index);
              } else {
                item.base_icms = 0;
                item.total_icms = 0;
              }
              this.calcularFCP(item.base_icms, item.base_icms_sub, index);
            } else if (st === "20") {
              if (this.configuracao.st_20 === "1") {
                item.base_icms = item.total - (item.total * item.reducao) / 100;
                item.total_icms = (item.base_icms * item.icms) / 100;
                item.base_icms_sub = 0;
                item.total_icms_sub = 0;
              } else {
                item.base_icms = 0;
                item.total_icms = 0;
              }
              this.calcularFCP(item.base_icms, item.base_icms_sub, index);
            } else if (st === "30") {
              if (this.configuracao.st_30 === "1") {
                item.base_icms = item.total;
                item.total_icms = (item.base_icms * item.icms) / 100;
                item.base_icms_sub = this.calculaBCST(index);
                item.total_icms_sub = this.calculaICMSST(index);
              } else {
                item.base_icms = 0;
                item.total_icms = 0;
              }
              this.calcularFCP(item.base_icms, item.base_icms_sub, index);
            } else if (st === "40") {
              if (this.configuracao.st_40 === "1") {
                item.base_icms = item.total - (item.total * item.reducao) / 100;
                item.total_icms = (item.base_icms * item.icms) / 100;
                item.base_icms_sub = 0;
                item.total_icms_sub = 0;
              } else {
                item.base_icms = 0;
                item.total_icms = 0;
              }
              this.calcularFCP(0, 0, index);
            } else if (st === "41") {
              if (this.configuracao.st_41 === "1") {
                item.base_icms = item.total - (item.total * item.reducao) / 100;
                item.total_icms = (item.base_icms * item.icms) / 100;
                item.base_icms_sub = 0;
                item.total_icms_sub = 0;
              } else {
                item.base_icms = 0;
                item.total_icms = 0;
              }
              this.calcularFCP(0, 0, index);
            } else if (st === "50") {
              if (this.configuracao.st_50 === "1") {
                item.base_icms = item.total - (item.total * item.reducao) / 100;
                item.total_icms = (item.base_icms * item.icms) / 100;
                item.base_icms_sub = 0;
                item.total_icms_sub = 0;
              } else {
                item.base_icms = 0;
                item.total_icms = 0;
              }
              this.calcularFCP(0, 0, index);
            } else if (st === "51") {
              if (this.configuracao.st_51 === "1") {
                item.base_icms = item.total - (item.total * item.reducao) / 100;
                item.total_icms = (item.base_icms * item.icms) / 100;
                item.base_icms_sub = 0;
                item.total_icms_sub = 0;
              } else {
                item.base_icms = 0;
                item.total_icms = 0;
              }
              this.calcularFCP(item.base_icms, item.base_icms_sub, index);
            } else if (st === "60") {
              if (this.configuracao.st_60 === "1") {
                item.base_icms = item.total - (item.total * item.reducao) / 100;
                item.total_icms = (item.base_icms * item.icms) / 100;
                item.base_icms_sub = 0;
                item.total_icms_sub = 0;
              } else {
                item.base_icms = 0;
                item.total_icms = 0;
                item.base_icms_sub = 0;
                item.total_icms_sub = 0;
              }
              this.calcularFCP(item.base_icms, item.base_icms_sub, index);
            } else if (st === "70") {
              if (this.configuracao.st_70 === "1") {
                item.base_icms = item.total - (item.total * item.reducao) / 100;
                item.total_icms = (item.base_icms * item.icms) / 100;
                item.base_icms_sub = this.calculaBCST(index);
                item.total_icms_sub = this.calculaICMSST(index);
              } else {
                item.base_icms = 0;
                item.total_icms = 0;
              }
              this.calcularFCP(item.base_icms, item.base_icms_sub, index);
            } else if (st === "90") {
              if (this.configuracao.st_90 === "1") {
                item.base_icms = item.total - (item.total * item.reducao) / 100;
                item.total_icms = (item.base_icms * item.icms) / 100;
                item.base_icms_sub = this.calculaBCST(index);
                item.total_icms_sub = this.calculaICMSST(index);
              } else {
                item.base_icms = 0;
                item.total_icms = 0;
              }
              this.calcularFCP(item.base_icms, item.base_icms_sub, index);
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    calcularFCP(base, base_st, index) {
      var item = this.venda.PdvItem[index];
      try {
        if (item.p_fcp && item.p_fcp_st) {
          item.v_fcp = parseFloat((base * item.p_fcp) / 100).toFixed(2);
          item.v_fcp_st = parseFloat((base * item.p_fcp_st) / 100).toFixed(2);
        } else {
          item.v_fcp = 0;
          item.v_fcp_st = 0;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async adicionarQtdProduto(index) {
      let produto = this.venda.PdvItem[index];
      produto.qtd += 1;
      this.preencheProdutoSelecionado(produto, false, index);
      this.codigoFocus();
    },

    async removerQtdProduto(index) {
      let produto = this.venda.PdvItem[index];
      if (produto.qtd - 1 > 0) {
        produto.qtd -= 1;
        this.preencheProdutoSelecionado(produto, false, index);
      }
      this.codigoFocus();
    },

    checkScroll() {
      if (!this.scrollImages) return;
      const currentScroll = this.scrollImages.scrollLeft;
      if (currentScroll === 0) {
        this.$refs.leftButton.setAttribute("disabled", "true");
        this.$refs.rightButton.removeAttribute("disabled");
      } else if (currentScroll === this.scrollLength) {
        this.$refs.rightButton.setAttribute("disabled", "true");
        this.$refs.leftButton.removeAttribute("disabled");
      } else {
        this.$refs.leftButton.removeAttribute("disabled");
        this.$refs.rightButton.removeAttribute("disabled");
      }
    },
    leftScroll() {
      if (!this.scrollImages) return;
      this.scrollImages.scrollBy({
        left: -200,
        behavior: "smooth",
      });
    },
    rightScroll() {
      if (!this.scrollImages) return;
      this.scrollImages.scrollBy({
        left: 200,
        behavior: "smooth",
      });
    },
    async currentPageChange(val) {
      this.codigoFocus();
      this.pagination.page = val;
      this.carregarProdutosGrupo();
    },
    codigoFocus() {
      document.getElementById("txtCodigo").focus();
      // setTimeout(() => {
      //   document.getElementById("txtCodigo").focus();
      // }, 600);
    },
    async carregarConfiguracoes() {
      try {
        var ret = await this.$store.dispatch(
          "configuracao/getConfiguracaoOData",
          "?$select=st_00,st_10,st_20,st_30,st_40,st_41,st_50,st_51,st_60,st_70,st_90"
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.configuracao = ret.value[0];
        }
      } catch (error) {
        console.log(error);
      }
    },
    async focusElement(element) {
      setTimeout(() => {
        const focusedElement = document.getElementById(element);
        if (focusedElement) {
          focusedElement.scrollIntoView({
            block: "center",
            inline: "center",
          });
        }
      }, 100);
    },
    async selectItem(index) {
      try {
        this.itemSelecionado = index;
        this.codigoFocus();
      } catch (error) {
        this.itemSelecionado = this.venda.PdvItem.length - 1;
      }
    },
    async handleArrowKeys(event) {
      if (event.key === "ArrowUp") {
        event.preventDefault();
        event.stopPropagation();
        if (this.itemSelecionado > 0) {
          this.itemSelecionado--;
          this.focusElement("prod" + this.itemSelecionado);
        }
      } else if (event.key === "ArrowDown") {
        event.preventDefault();
        event.stopPropagation();
        if (this.itemSelecionado < this.venda.PdvItem.length - 1) {
          this.itemSelecionado++;
          this.focusElement("prod" + this.itemSelecionado);
        }
      } else if (event.key === "Insert") {
        event.preventDefault();
        event.stopPropagation();
        this.informarQuantidade();
      } else if (event.key === "PageUp") {
        event.preventDefault();
        event.stopPropagation();
        this.modalProdutos(true);
      } else if (event.key === "Delete") {
        event.preventDefault();
        event.stopPropagation();
        this.removerProduto(this.itemSelecionado);
      } else if (event.key === "F6") {
        event.preventDefault();
        event.stopPropagation();
        this.cancelarVendaTemp();
      } else if (event.key === "F3") {
        event.preventDefault();
        event.stopPropagation();
        this.modalClientes(true);
      } else if (event.key === "F5") {
        event.preventDefault();
        event.stopPropagation();
        this.finalizarVenda();
      }
    },

    async exibirModalEditarQuantidade(exibir) {
      this.exibirQtd = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_pdv_qtd",
          /*open*/ () => {
            this.$utils.requestFocus("txtQtd");
          },
          /*close*/ () => {
            this.exibirModalEditarQuantidade(false);
          }
        );
      } else {
        this.codigoFocus();
      }
    },

    async confirmarModalEditarQuantidade(qtd) {
      this.qtdAtual = qtd;
      this.codigoFocus();
    },

    async informarQuantidade() {
      this.exibirModalEditarQuantidade(true);
    },

    async exibirModalLeituraBarras(exibir) {
      this.exibirLeituraBarras = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_leitura_barras",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_leitura_barras");
          },
          /*close*/ () => {
            this.exibirModalLeituraBarras(false);
          }
        );
      } else {
        this.codigoFocus();
      }
    },

    async confirmarModalLeituraBarras(barras) {
      this.pesquisaProduto = barras;
      this.codigoFocus();
      if (this.loadingProduto === false) {
        this.loadingProduto = true;
        this.incluirProduto();
      }
    },

    async executarLeituraBarras() {
      this.exibirModalLeituraBarras(true);
    },

    modalProdutos(exibir) {
      this.exibirPesquisaProdutos = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_produtos_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarProdutos");
          },
          /*close*/ () => {
            this.modalProdutos(false);
          }
        );
      } else {
        this.codigoFocus();
      }
    },

    async removerProduto(index) {
      if (this.venda.PdvItem.length > 0) {
        await this.$swal.showQuestionAlert(
          "Deseja remover o item selecionado?",
          async (alert) => {
            if (alert.isConfirmed) {
              this.errosGerais = {};
              this.loadingItensVenda = true;

              this.venda.PdvItem.splice(index, 1);
              await this.recalcularValores();

              this.itemSelecionado =
                this.venda.PdvItem.length > 0
                  ? this.venda.PdvItem.length - 1
                  : 0;
              this.focusElement("prod" + this.itemSelecionado);
              this.codigoFocus();
              this.loadingItensVenda = false;
            } else {
              this.codigoFocus();
            }
          }
        );
      }
    },
    async cancelarVendaTemp() {
      await this.$swal.showQuestionAlert(
        "Deseja cancelar a venda atual?",
        async (alert) => {
          if (alert.isConfirmed) {
            this.errosGerais = {};
            this.loadingItensVenda = true;

            this.venda = JSON.parse(JSON.stringify(vendaInicializada));
            this.pesquisaProduto = "";
            await this.recalcularValores();

            this.codigoFocus();
            this.loadingItensVenda = false;
          } else {
            this.codigoFocus();
          }
        }
      );
    },

    async modalClientes(exibir) {
      this.exibirClientes = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_clientes_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarClientes");
          },
          /*close*/ () => {
            this.modalClientes(false);
          }
        );
      } else {
        this.codigoFocus();
      }
    },

    async selecionarCliente(cliente) {
      this.venda.id_cliente = cliente.id;
      this.errosGerais = {};
      try {
        var ret = await this.$store.dispatch("cliente/getCliente", cliente.id);
        if (ret.Success === true) {
          cliente = ret.Data;
          if (cliente && cliente !== null) {
            this.venda.Cliente = cliente;
            this.venda.cliente_nome = cliente.nome;
            this.venda.cliente_documento = cliente.cpf_cnpj;
          }
        }
      } catch (error) {
        this.errosGerais = error;
      }
    },

    onScroll() {
      let navBar = document.getElementById("kt_produto_input_lancamento");
      if (window.scrollY > navBar.offsetTop) {
        navBar.classList.add("fixed-top", "shadow");
      } else {
        navBar.classList.remove("fixed-top", "shadow");
      }
    },

    async finalizarVenda() {
      this.exibirModalFinalizarVenda(true);
    },

    async exibirModalFinalizarVenda(exibir) {
      this.exibirFinalizarVenda = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_finalizar_venda",
          /*open*/ () => {
            this.$utils.requestFocus("txtValor");
          },
          /*close*/ () => {
            this.exibirModalFinalizarVenda(false);
          }
        );
      } else {
        this.codigoFocus();
      }
    },

    async confirmarModalFinalizarVenda() {
      this.codigoFocus();
    },

    async exibirModalLoading(exibir, callback) {
      if (exibir === true) {
        this.loadingGeral = true;
        getOrCreateInstanceModal(
          "loadingModalPDV",
          /*open*/ null,
          /*close*/ null
        );
      } else {
        hideModalId("loadingModalPDV", () => {
          this.loadingGeral = false;
          this.$nextTick(() => {
            if (callback) {
              callback();
            }
          });
        });
      }
    },

    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
  async mounted() {
    await this.carregarConfiguracoes();
    this.carregarGrupos();
    this.codigoFocus();
    window.addEventListener("keydown", this.handleArrowKeys);
    window.addEventListener("scroll", this.onScroll);
    setTimeout(MenuComponent.reinitialization, 500);
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.handleArrowKeys);
    window.removeEventListener("scroll", this.onScroll);
  },
  data() {
    return {
      timeOut: null,
      exibirClientes: false,
      exibirPesquisaProdutos: false,
      modalComponent: null,
      loadingGeral: null,
      loadingMensagem: "",
      loadingProduto: false,
      loadingProdutos: false,
      loadingGrupos: false,
      loadingItensVenda: false,
      venda: JSON.parse(JSON.stringify(vendaInicializada)),
      filterOData: "",
      searchValue: "",
      grupos: [],
      produtos: [],
      grupoSelecionado: null,
      itemSelecionado: null,
      scrollImages: null,
      scrollLength: 0,
      eventoScrollRegistrado: false,
      pesquisaProduto: "",
      qtdAtual: 1,
      configuracao: {},
      exibirQtd: false,
      exibirLeituraBarras: false,
      pgUP: false,
      active: false,
      exibirFinalizarVenda: false,
      pagination: {
        page: 1,
        rowsPerPage: 12,
        total: 0,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.cover {
  position: relative;
  padding: 0px 30px;
}
.left {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
.right {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.scroll-images {
  position: relative;
  width: 100%;
  padding: 0px 0px;
  height: auto;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: hidden;
  overflow-y: hidden;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
}

.child-scroll-images {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 200px;
  height: 80px;
  overflow: hidden;
}

.button-scroll {
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  font-size: 25px;
}

#kt_produtos_container {
  height: calc(100vh - 120px);
}

@media screen and (max-width: 768px) {
  #kt_produtos_container {
    height: auto;
  }
}

#kt_geral {
  height: calc(100vh - 120px);
  background-color: transparent;
}

@media screen and (max-width: 768px) {
  #kt_geral {
    height: auto;
    max-height: calc(100vh - 120px);
  }
}

#kt_produtos_body {
  flex: 1;
  overflow-y: auto;
}
</style>
